import { Box, Flex, Image, List, ListItem } from '@chakra-ui/react';
import { Trans, useTranslation } from 'react-i18next';

import { TextBold, TextMedium, TextRegular } from 'UiKit/typography';
import Drawer from 'UiKit/drawer';
import Badge from 'UiKit/badge';
import { AlertIcon, CloseIcon } from 'Asset/icon';
import lazadaImage from 'Asset/image/lazada-image.png';
import { Element, Iteration } from 'Component/others';

import styles from './styles.module.css';

const DrawerInfo = ({ isOpen, onClose }) => {
  const { t } = useTranslation('host-schedule');
  return (
    <Drawer className={styles['drawer__container']} height="80vh" isOpen={isOpen} onClose={onClose}>
      <Box className={styles['section__head']}>
        <TextBold className={styles['section__title']}>{t('achievement_status_info.title')}</TextBold>
        <CloseIcon size="18px" onClick={onClose} />
      </Box>

      <Box className={styles['section__content']}>
        <Box className={styles['content__item']}>
          <Badge className={styles['badge__container']}>{t('achievement_status_info.not_yet_available.title')}</Badge>
          <TextBold className={styles['content__text--bold']}>{t('achievement_status_info.not_yet_available.desc')}</TextBold>
          <List>
            <Iteration
              items={t('achievement_status_info.not_yet_available.causes', { returnObjects: true })}
              render={(reason, index) => (
                <ListItem className={styles['content__text--regular']} key={index}>
                  <Box as="span">•</Box>
                  <Element value={reason} />
                </ListItem>
              )}
            />
          </List>
        </Box>

        <Box className={styles['content__item']}>
          <Badge variant="warn" className={styles['badge__container']}>
            {t('achievement_status_info.partially_available.title')}
          </Badge>
          <TextBold className={styles['content__text--bold']}>{t('achievement_status_info.partially_available.desc')}</TextBold>
          <List>
            <Iteration
              items={t('achievement_status_info.partially_available.causes', { returnObjects: true })}
              render={(reason, index) => (
                <ListItem className={styles['content__text--regular']} key={index}>
                  <Box as="span">•</Box>
                  <Element value={reason} />
                </ListItem>
              )}
            />
          </List>
        </Box>

        <Box className={styles['content__item']}>
          <Badge variant="success" className={styles['badge__container']}>
            {t('achievement_status_info.available.title')}
          </Badge>
          <List>
            <Iteration
              items={t('achievement_status_info.available.causes', { returnObjects: true })}
              render={(reason, index) => (
                <ListItem className={styles['content__text--regular']} key={index}>
                  <Box as="span">•</Box>
                  <Element value={reason} />
                </ListItem>
              )}
            />
          </List>
        </Box>

        <Box className={`${styles['content__item']} ${styles['content__item--platform']}`}>
          <Box as="span">•</Box>
          <Flex className={styles['content__platform']}>
            <TextMedium className={styles['content__text--regular']}>
              <Trans
                i18nKey="achievement_status_info.platform_unavailable"
                ns="host-schedule"
                components={{
                  badge: (
                    <Box className={styles['platform']}>
                      <Image src={lazadaImage} />
                      <TextRegular>Lazada</TextRegular>
                    </Box>
                  ),
                }}
              />
            </TextMedium>
          </Flex>
        </Box>

        <Box className={styles['contact-us__container']}>
          <AlertIcon size="20px" />
          <TextMedium className={styles['contact-us__text']}>{t('achievement_status_info.contact_operator')} </TextMedium>
        </Box>
      </Box>
    </Drawer>
  );
};

export default DrawerInfo;
